export const PROVINCES = [
	"An Giang",
	"Bà Rịa - Vũng Tàu",
	"Bắc Giang",
	"Bắc Kạn",
	"Bạc Liêu",
	"Bắc Ninh",
	"Bến Tre",
	"Bình Định",
	"Bình Dương",
	"Bình Phước",
	"Bình Thuận",
	"Cà Mau",
	"Cần Thơ",
	"Cao Bằng",
	"Đà Nẵng",
	"Đắk Lắk",
	"Đắk Nông",
	"Điện Biên",
	"Đồng Nai",
	"Đồng Tháp",
	"Gia Lai",
	"Hà Giang",
	"Hà Nam",
	"Hà Nội",
	"Hà Tĩnh",
	"Hải Dương",
	"Hải Phòng",
	"Hậu Giang",
	"Hòa Bình",
	"Hưng Yên",
	"Khánh Hòa",
	"Kiên Giang",
	"Kon Tum",
	"Lai Châu",
	"Lâm Đồng",
	"Lạng Sơn",
	"Lào Cai",
	"Long An",
	"Nam Định",
	"Nghệ An",
	"Ninh Bình",
	"Ninh Thuận",
	"Phú Thọ",
	"Phú Yên",
	"Quảng Bình",
	"Quảng Nam",
	"Quảng Ngãi",
	"Quảng Ninh",
	"Quảng Trị",
	"Sóc Trăng",
	"Sơn La",
	"Tây Ninh",
	"Thái Bình",
	"Thái Nguyên",
	"Thanh Hóa",
	"Thừa Thiên - Huế",
	"Tiền Giang",
	"TP. Hồ Chí Minh",
	"Trà Vinh",
	"Tuyên Quang",
	"Vĩnh Long",
	"Vĩnh Phúc",
	"Yên Bái",
];

// 0x1 : Northeast
// 0x2 : Northwest
// 0x4 : Red River Delta
// 0x8 : North Central Coast
// 0x10 : South Central Coast
// 0x20 : Central Highlands
// 0x40 : Southeast
// 0x80 : Mekong River Delta

export const VIETNAM_REGIONS_BITFLAG = [
    0x80, // An Giang
    0x40, // Ba Ria - Vung Tau
    0x1,  // Bac Giang
    0x1,  // Bac Kan
    0x80, // Bac Lieu
    0x4,  // Bac Ninh
    0x80, // Ben Tre
    0x10, // Binh Dinh
    0x40, // Binh Duong
    0x40, // Binh Phuoc
    0x10, // Binh Thuan
    0x80, // Ca Mau
    0x80, // Can Tho
    0x1,  // Cao Bang
    0x10, // Da Nang
    0x20, // Dak Lak
    0x20, // Dak Nong
    0x2,  // Dien Bien
    0x40, // Dong Nai
    0x80, // Dong Thap
    0x20, // Gia Lai
    0x1,  // Ha Giang
    0x4,  // Ha Nam
    0x4,  // Ha Noi
    0x8,  // Ha Tinh
    0x4,  // Hai Duong
    0x4,  // Hai Phong
    0x80, // Hau Giang
    0x2,  // Hoa Binh
    0x4,  // Hung Yen
    0x10, // Khanh Hoa
    0x80, // Kien Giang
    0x20, // Kon Tum
    0x2,  // Lai Chau
    0x20, // Lam Dong
    0x1,  // Lang Son
    0x2,  // Lao Cai
    0x80, // Long An
    0x4,  // Nam Dinh
    0x8,  // Nghe An
    0x4,  // Ninh Binh
    0x10, // Ninh Thuan
    0x1,  // Phu Tho
    0x10, // Phu Yen
    0x8,  // Quang Binh
    0x10, // Quang Nam
    0x10, // Quang Ngai
    0x1,  // Quang Ninh
    0x8,  // Quang Tri
    0x80, // Soc Trang
    0x2,  // Son La
    0x40, // Tay Ninh
    0x4,  // Thai Binh
    0x1,  // Thai Nguyen
    0x8,  // Thanh Hoa
    0x8,  // Thua Thien - Hue
    0x80, // Tien Giang
    0x40, // TP. Ho Chi Minh
    0x80, // Tra Vinh
    0x1,  // Tuyen Quang
    0x80, // Vinh Long
    0x4,  // Vinh Phuc
    0x2,  // Yen Bai
];
